
// форма "Оплатить заём картой любого банка" (Т-Банк)
const ID_TEST_INPUT_CONTRACT = 'test-input-contract'; // для поля ввода "Номер договора"
const ID_TEST_INPUT_PHONE = 'test-input-phone'; // для поля ввода "Телефона"
const ID_TEST_INPUT_RAW_AMOUNT = 'test-input-raw_amount'; // для поля ввода "Суммы"
const ID_TEST_CHECKBOX_AGREE = 'test-checkbox-agree'; // для чекбокса "С правилами ознакомлен"
const ID_TEST_BUTTON_PAY = 'test-button-pay'; // для кнопки "Оплатить"
const ID_TEST_SPAN_TOTAL = 'test-span-total'; // для цифры "Итого к оплате"
const ID_TEST_SPAN_COMISSION = 'test-span-commission'; // для цифры "В том числе, комиссия:"

// Плитка "Байбол" из секции "Где оплатить?"
const ID_TEST_A_RUSTORE = 'test-a-rustore'; // ссылка на скачивание приложения из рустора
const ID_TEST_A_GOOGLE = 'test-a-google'; // ссылка на скачивание приложения из гугла
const ID_TEST_A_APK = 'test-a-apk'; // ссылка на скачивание apk приложения

export {
    ID_TEST_INPUT_CONTRACT,
    ID_TEST_INPUT_PHONE,
    ID_TEST_INPUT_RAW_AMOUNT,
    ID_TEST_CHECKBOX_AGREE,
    ID_TEST_BUTTON_PAY,
    ID_TEST_SPAN_TOTAL,
    ID_TEST_SPAN_COMISSION,
    ID_TEST_A_RUSTORE,
    ID_TEST_A_GOOGLE,
    ID_TEST_A_APK
};